import bedType from "./bedType/zh_cn.yml";
import bedSizeType from "./bedSizeType/zh_cn.yml";
import mealType from "./mealType/zh_cn.yml";
import chargeType from "./chargeType/zh_cn.yml";
import payType from "./payType/zh_cn.yml";
import languageType from "./languageType/zh_cn.yml";
import adminUserRoleType from "./adminUserRoleType/zh_cn.yml";
import adminUserStatus from "./adminUserStatus/zh_cn.yml";
import companyStatus from "./companyStatus/zh_cn.yml";
import companyAdminUserRoleType from "./companyAdminUserRoleType/zh_cn.yml";
import hotelStatus from "./hotelStatus/zh_cn.yml";
import hotelCancelPolicyType from "./hotelCancelPolicyType/zh_cn.yml";
import hotelCancelType from "./hotelCancelType/zh_cn.yml";
import channelManagerType from "./channelManagerType/zh_cn.yml";
import hotelMealType from "./hotelMealType/zh_cn.yml";
import hotelPlanType from "./hotelPlanType/zh_cn.yml";
import hotelPlanStatus from "./hotelPlanStatus/zh_cn.yml";
import hotelRoomStatus from "./hotelRoomStatus/zh_cn.yml";
import hotelOptionStatus from "./hotelOptionStatus/zh_cn.yml";
import hotelChildrenSettingType from "./hotelChildrenSettingType/zh_cn.yml";
import hotelChildrenSettingCategorySimple from "./hotelChildrenSettingCategorySimple/zh_cn.yml";
import hotelChildrenSettingCategoryComplexChildrenSetting from "./hotelChildrenSettingCategoryComplexChildrenSetting/zh_cn.yml";
import hotelChildrenSettingCategorySimpleChildrenSetting from "./hotelChildrenSettingCategorySimpleChildrenSetting/zh_cn.yml";
import hotelChildrenSettingMealType from "./hotelChildrenSettingMealType/zh_cn.yml";
import hotelChildrenSettingPriceType from "./hotelChildrenSettingPriceType/zh_cn.yml";
import hotelChildrenSearchDisplayType from "./hotelChildrenSearchDisplayType/zh_cn.yml";
import hotelQuestionType from "./hotelQuestionType/zh_cn.yml";
import hotelQuestionAnswerType from "./hotelQuestionAnswerType/zh_cn.yml";
import hotelQuestionApplicableConditionType from "./hotelQuestionApplicableConditionType/zh_cn.yml";
import hotelOptionPriceType from "./hotelOptionPriceType/zh_cn.yml";
import hotelOptionApplicableConditionType from "./hotelOptionApplicableConditionType/zh_cn.yml";
import hotelFilterType from "./hotelFilterType/zh_cn.yml";
import hotelWaitingListType from "./hotelWaitingListType/zh_cn.yml";
import hotelWaitingListStatus from "./hotelWaitingListStatus/zh_cn.yml";
import hotelMailType from "./hotelMailType/zh_cn.yml";
import hotelPriceChargeType from "./hotelPriceChargeType/zh_cn.yml";
import hotelPriceUpdateType from "./hotelPriceUpdateType/zh_cn.yml";
import hotelInventoryStatus from "./hotelInventoryStatus/zh_cn.yml";
import hotelBillingType from "./hotelBillingType/zh_cn.yml";
import hotelCheckInQuestionType from "./hotelCheckInQuestionType/zh_cn.yml";
import hotelCheckInAnswererType from "./hotelCheckInAnswererType/zh_cn.yml";
import hotelCheckInRequiredGuestInfoScope from "./hotelCheckInRequiredGuestInfoScope/zh_cn.yml";
import hotelCheckInStatus from "./hotelCheckInStatus/zh_cn.yml";
import hotelPushMessageGroupPlatformType from "./hotelPushMessageGroupPlatformType/zh_cn.yml";
import hotelPushMessageGroupStatus from "./hotelPushMessageGroupStatus/zh_cn.yml";
import listTypes from "./listTypes/zh_cn.yml";
import bookingStatus from "./bookingStatus/zh_cn.yml";
import bookingOptionStatus from "./bookingOptionStatus/zh_cn.yml";
import bookingPayType from "./bookingPayType/zh_cn.yml";
import bookingPayTypeShort from "./bookingPayTypeShort/zh_cn.yml";
import cancelPolicyOption from "./cancelPolicyOption/zh_cn.yml";
import seo from "./seo/zh_cn.yml";
import defaultSortBy from "./defaultSortBy/zh_cn.yml";
import roomPlanDisplayType from "./roomPlanDisplayType/zh_cn.yml";
import inventoryUnit from "./inventoryUnit/zh_cn.yml";
import promotionType from "./promotionType/zh_cn.yml";
import promotionStatus from "./promotionStatus/zh_cn.yml";
import promotionStayType from "./promotionStayType/zh_cn.yml";
import promotionDiscountType from "./promotionDiscountType/zh_cn.yml";
import promotionApplicableConditionType from "./promotionApplicableConditionType/zh_cn.yml";
import promotionFixedDiscountApplyTargetType from "./promotionFixedDiscountApplyTargetType/zh_cn.yml";
import bankDepositType from "./bankDepositType/zh_cn.yml";
import userType from "./userType/zh_cn.yml";
import userStatus from "./userStatus/zh_cn.yml";
import newsletterStatus from "./newsletterStatus/zh_cn.yml";
import dayOfWeekShort from "./dayOfWeekShort/zh_cn.yml";
import genderType from "./genderType/zh_cn.yml";
import messageType from "./messageType/zh_cn.yml";
import hotelStayType from "./hotelStayType/zh_cn.yml";
import hotelDisplayCalendarType from "./hotelDisplayCalendarType/zh_cn.yml";
import hotelDisplayPriceType from "./hotelDisplayPriceType/zh_cn.yml";
import hotelPlanBookingStatus from "./hotelPlanBookingStatus/zh_cn.yml";
import hotelFacilityType from "./hotelFacilityType/zh_cn.yml";
import { zh_cn as hotelGoogleHotelStatus } from "./hotelGoogleHotelStatus/zh_cn.yml";
import { zh_cn as hotelLinkType } from "./hotelLinkType/zh_cn.yml";

export const constantZhCn: any = {
  bedType: bedType["zh_cn"]["adminConstantBedType"],
  bedSizeType: bedSizeType["zh_cn"]["adminConstantBedSizeType"],
  mealType: mealType["zh_cn"]["adminConstantMealType"],
  chargeType: chargeType["zh_cn"]["adminConstantChargeType"],
  payType: payType["zh_cn"]["adminConstantPayType"],
  languageType: languageType["zh_cn"]["adminConstantLanguageType"],
  adminUserRoleType:
    adminUserRoleType["zh_cn"]["adminConstantAdminUserRoleType"],
  adminUserStatus: adminUserStatus["zh_cn"]["adminConstantAdminUserStatus"],
  companyStatus: companyStatus["zh_cn"]["adminConstantCompanyStatus"],
  companyAdminUserRoleType:
    companyAdminUserRoleType["zh_cn"]["adminConstantCompanyAdminUserRoleType"],
  hotelStatus: hotelStatus["zh_cn"]["adminConstantHotelStatus"],
  hotelCancelPolicyType:
    hotelCancelPolicyType["zh_cn"]["adminConstantHotelCancelPolicyType"],
  hotelCancelType: hotelCancelType["zh_cn"]["adminConstantHotelCancelType"],
  hotelMealType: hotelMealType["zh_cn"]["adminConstantHotelMealType"],
  hotelChildrenSettingType:
    hotelChildrenSettingType["zh_cn"]["adminConstantHotelChildrenSettingType"],
  hotelChildrenSettingCategorySimple:
    hotelChildrenSettingCategorySimple["zh_cn"][
      "adminConstantHotelChildrenSettingCategorySimple"
    ],
  hotelChildrenSettingCategoryComplexChildrenSetting:
    hotelChildrenSettingCategoryComplexChildrenSetting["zh_cn"][
      "adminConstantHotelChildrenSettingCategoryComplexChildrenSetting"
    ],
  hotelChildrenSettingCategorySimpleChildrenSetting:
    hotelChildrenSettingCategorySimpleChildrenSetting["zh_cn"][
      "adminConstantHotelChildrenSettingCategorySimpleChildrenSetting"
    ],
  hotelChildrenSettingMealType:
    hotelChildrenSettingMealType["zh_cn"][
      "adminConstantHotelChildrenSettingMealType"
    ],
  hotelChildrenSettingPriceType:
    hotelChildrenSettingPriceType["zh_cn"][
      "adminConstantHotelChildrenSettingPriceType"
    ],
  hotelChildrenSearchDisplayType:
    hotelChildrenSearchDisplayType["zh_cn"][
      "adminConstantHotelChildrenSearchDisplayType"
    ],
  hotelQuestionType:
    hotelQuestionType["zh_cn"]["adminConstantHotelQuestionType"],
  hotelQuestionAnswerType:
    hotelQuestionAnswerType["zh_cn"]["adminConstantHotelQuestionAnswerType"],
  hotelQuestionApplicableConditionType:
    hotelQuestionApplicableConditionType["zh_cn"][
      "adminConstantHotelQuestionApplicableConditionType"
    ],
  hotelOptionPriceType:
    hotelOptionPriceType["zh_cn"]["adminConstantHotelOptionPriceType"],
  hotelOptionApplicableConditionType:
    hotelOptionApplicableConditionType["zh_cn"][
      "adminConstantHotelOptionApplicableConditionType"
    ],
  hotelFilterType: hotelFilterType["zh_cn"]["adminConstantHotelFilterType"],
  hotelWaitingListType:
    hotelWaitingListType["zh_cn"]["adminConstantHotelWaitingListType"],
  hotelWaitingListStatus:
    hotelWaitingListStatus["zh_cn"]["adminConstantHotelWaitingListStatus"],
  channelManagerType:
    channelManagerType["zh_cn"]["adminConstantChannelManagerType"],
  listTypes: listTypes["zh_cn"]["adminConstantListTypes"],
  bookingStatus: bookingStatus["zh_cn"]["adminConstantBookingStatus"],
  bookingOptionStatus:
    bookingOptionStatus["zh_cn"]["adminConstantBookingOptionStatus"],
  bookingPayType: bookingPayType["zh_cn"]["adminConstantBookingPayType"],
  bookingPayTypeShort:
    bookingPayTypeShort["zh_cn"]["adminConstantBookingPayTypeShort"],
  hotelMailType: hotelMailType["zh_cn"]["adminConstantHotelMailType"],
  cancelPolicyOption: cancelPolicyOption["zh_cn"]["adminCancelPolicyOption"],
  hotelPlanType: hotelPlanType["zh_cn"]["adminConstantHotelPlanType"],
  hotelPlanStatus: hotelPlanStatus["zh_cn"]["adminConstantHotelPlanStatus"],
  hotelRoomStatus: hotelRoomStatus["zh_cn"]["adminConstantHotelRoomStatus"],
  hotelOptionStatus:
    hotelOptionStatus["zh_cn"]["adminConstantHotelOptionStatus"],
  hotelPriceChargeType:
    hotelPriceChargeType["zh_cn"]["adminConstantHotelPriceChargeType"],
  hotelPriceUpdateType:
    hotelPriceUpdateType["zh_cn"]["adminConstantHotelPriceUpdateType"],
  hotelInventoryStatus:
    hotelInventoryStatus["zh_cn"]["adminConstantHotelInventoryStatus"],
  hotelBillingType: hotelBillingType["zh_cn"]["adminConstantHotelBillingType"],
  hotelCheckInQuestionType:
    hotelCheckInQuestionType["zh_cn"]["adminConstantHotelCheckInQuestionType"],
  hotelCheckInAnswererType:
    hotelCheckInAnswererType["zh_cn"]["adminConstantHotelCheckInAnswererType"],
  hotelCheckInRequiredGuestInfoScope:
    hotelCheckInRequiredGuestInfoScope["zh_cn"][
      "adminConstantHotelCheckInRequiredGuestInfoScope"
    ],
  hotelCheckInStatus:
    hotelCheckInStatus["zh_cn"]["adminConstantHotelCheckInStatus"],
  hotelPushMessageGroupPlatformType:
    hotelPushMessageGroupPlatformType["zh_cn"][
      "adminConstantHotelPushMessageGroupPlatformType"
    ],
  hotelPushMessageGroupStatus:
    hotelPushMessageGroupStatus["zh_cn"][
      "adminConstantHotelPushMessageGroupStatus"
    ],
  seo: seo["zh_cn"]["adminConstantSeo"],
  defaultSortBy: defaultSortBy["zh_cn"]["adminConstantDefaultSortBy"],
  roomPlanDisplayType:
    roomPlanDisplayType["zh_cn"]["adminConstantRoomPlanDisplayType"],
  inventoryUnit: inventoryUnit["zh_cn"]["adminConstantInventoryUnit"],
  promotionType: promotionType["zh_cn"]["adminConstantPromotionType"],
  promotionStatus: promotionStatus["zh_cn"]["adminConstantPromotionStatus"],
  promotionStayType:
    promotionStayType["zh_cn"]["adminConstantPromotionStayType"],
  promotionDiscountType:
    promotionDiscountType["zh_cn"]["adminConstantPromotionDiscountType"],
  promotionApplicableConditionType:
    promotionApplicableConditionType["zh_cn"][
      "adminConstantPromotionApplicableConditionType"
    ],
  promotionFixedDiscountApplyTargetType:
    promotionFixedDiscountApplyTargetType["zh_cn"][
      "adminConstantPromotionFixedDiscountApplyTargetType"
    ],
  bankDepositType: bankDepositType["zh_cn"]["adminConstantBankDepositType"],
  userType: userType["zh_cn"]["adminConstantUserType"],
  userStatus: userStatus["zh_cn"]["adminConstantUserStatus"],
  newsletterStatus: newsletterStatus["zh_cn"]["adminConstantNewsletterStatus"],
  dayOfWeekShort: dayOfWeekShort["zh_cn"]["adminConstantDayOfWeekShort"],
  genderType: genderType["zh_cn"]["adminConstantGenderType"],
  messageType: messageType["zh_cn"]["adminConstantMessageType"],
  hotelStayType: hotelStayType["zh_cn"]["adminConstantHotelStayType"],
  hotelDisplayCalendarType:
    hotelDisplayCalendarType["zh_cn"]["adminConstantHotelDisplayCalendarType"],
  hotelDisplayPriceType:
    hotelDisplayPriceType["zh_cn"]["adminConstantHotelDisplayPriceType"],
  hotelPlanBookingStatus:
    hotelPlanBookingStatus["zh_cn"]["adminConstantHotelPlanBookingStatus"],
  hotelFacilityType:
    hotelFacilityType["zh_cn"]["adminConstantHotelFacilityType"],
  hotelGoogleHotelStatus:
    hotelGoogleHotelStatus["adminConstantHotelGoogleHotelStatus"],
  hotelLinkType: hotelLinkType["adminConstantHotelLinkType"],
};
